import * as React from "react";
import Grid from "@mui/material/Grid/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography/Typography";
import Box from "@mui/material/Box/Box";
import Skeleton from "@mui/material/Skeleton/Skeleton";
import firebase from "../firebase/firebase";
import {useNavigate} from "react-router-dom";
import {AuthUserContext} from "../providers/AuthProvider";
import Dialog from "@mui/material/Dialog/Dialog";
import Portal from "@mui/material/Portal";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Button from "@mui/material/Button/Button";
import IconButton from "@mui/material/IconButton";

// Create a reference to the file we want to download
import CloseIcon from '@mui/icons-material/Close';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const storageRef = firebase.storage().ref();
function ArtistGridItem({ title, genre, posted, location, image, id}) {
  const { profile} = React.useContext(AuthUserContext)
  const [imageUrl, setImageUrl] = React.useState()
  const [loading, setLoading] = React.useState(true)
  const navigator = useNavigate()
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(()=> {
    if (image && image !== '') {
      const starsRef = storageRef.child(image);

// Get the download URL
      starsRef.getDownloadURL()
        .then((url) => {
          setImageUrl(url)
          setLoading(false)
          // Insert url into an <img> tag to "download"
        })
        .catch((error) => {
          setLoading(false)

          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/object-not-found':
              // File doesn't exist
              break;
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;
            case 'storage/canceled':
              // User canceled the upload
              break;

            // ...

            case 'storage/unknown':
              // Unknown error occurred, inspect the server response
              break;
          }
        });
    }
  }, [])
  return(
    <Grid
      item
      xs={12}
      sm={6}
      md={3}
    >
      <Box sx={{width: '100%', backgroundColor:'#E3E8F0', color: '#204488', boxShadow: "3px 4px 10px rgba(32, 68, 136, 0.5)",
        '&:hover': {
          backgroundColor: '#204488',
          color: '#fff',
          
        }, borderRadius: '10px', cursor:"pointer"}} onClick={() => profile && !profile?.membership ? setOpen(true) : navigator(`/creator/artist-details/${id}`)
      }>
        {loading ? <Skeleton animation={'pulse'} variant="rectangular" sx={{ bgcolor: '#ccc', borderTopLeftRadius:'10px',borderTopRightRadius:'10px' }} height={250} />:
          <img style={{height: 250, width:'100%', objectFit:'cover',borderTopRightRadius: '10px', borderTopLeftRadius: '10px'}}
               src={imageUrl}  alt=""/>
        }
        <Box sx={{width: '100%' , paddingX:2, pb: 2}}>

          <Typography variant={'h6'} noWrap={true} sx={{fontWeight:"500", fontSize:"20px"}} >
            {title}
          </Typography>

          <br/>
          <Typography variant={'body1'}  noWrap={true} sx={{fontSize:14}}  >
            Location: {location}
          </Typography>
          <Typography variant="body1" noWrap={true}  sx={{fontSize:14}} >
            {/* Skills: {genre && genre.length > 0 && genre?.map && genre.map((d) => (`${d}, `))} */}
            Skills: {genre && genre.length > 0 && genre?.map && genre.map((d) => (
                genre.length != 1 ? `${d}, ` : `${d}`
              )
            )}
          </Typography>
          <Stack direction={'row'} sx={{width: '100%', mt:1}}>
            <Typography variant={'body1'} sx={{fontSize:14, flex:1}} >
              Posted: {posted}
            </Typography>
            <FavoriteBorderIcon />
          </Stack>
        </Box>
      </Box>
      <Portal>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" >
            <Stack direction={'row'} spacing={2}>
              <Typography variant={'h6'} sx={{flex:1}}>You need to buy a membership to invest</Typography>
              <IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpen(false)}>
                <CloseIcon/>
              </IconButton>
            </Stack>


          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" >
              <Typography variant={'body2'}> In order to invest in this project, you need to buy a membership and upload your documentation for verification.</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{paddingX: 3, paddingY: 2}}>
            <Button onClick={() => setOpen(false)} size={'small'} sx={{color: '#000',paddingX: 3}}>Not now</Button>
            <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} onClick={() => {
              handleClose();
              navigator(`/${profile?.userType === 'investor'? 'investor' :profile?.userType === 'artist' ? 'artists' : 'creator' }/membership-plan`)
            }}>

              Buy membership
            </Button>
          </DialogActions>
        </Dialog>
      </Portal>


    </Grid>

  )
}
export default ArtistGridItem;